const hasPermission = (user, departmentId, allowedRoles) => {
    if (!user) return false;
    if (user.isSuperAdmin) return true;

    return user.roles.some(role =>
        role.department === departmentId && allowedRoles.includes(role.role)
    );
};

const canEdit = (user, object) => {
    if (!user || !object) return false;
    if (user.isSuperAdmin) return true;

    const departmentId = object.department?._id || object.department;
    if (!departmentId) return false;

    return hasPermission(user, departmentId, ['EDITOR', 'ADMIN']);
};

const canCreate = (user) => {
    if (!user) return false;
    if (user.isSuperAdmin) return true;

    return user.roles.some(role => ['EDITOR', 'ADMIN'].includes(role.role));
};

const isWaitingForApproval = (user) => {
    return user && (!user.roles || user.roles.length === 0) && user.pendingRequests && user.pendingRequests.length > 0;
}

export const permissions = {
    canEdit,
    canCreate,
    hasPermission,
    isWaitingForApproval,
};